import { useTreeTypes } from '@/features/fieldSlice';
import { Icon } from '@/components/Icon/Icon';
import type { RiskTypeConfig } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { useClientTerminology } from '@/hooks/useClientTerminology';
import { capitalize } from '@/helpers/stringConversion';
import { HelpPopover } from '@/components/HelpPopover/HelpPopover';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';
import classes from './FallInRiskLegend.module.css';

export const FallInRiskLegend = (props: { layerConfig: RiskTypeConfig }) => {
  const { getClientTerm } = useClientTerminology();
  const isSmallScreen = useSmallScreen();
  const treeTypes = useTreeTypes();

  if (
    treeTypes.every(
      (treeType) => !props.layerConfig[`show${capitalize(treeType)}Trees`]
    )
  ) {
    return null;
  }

  return (
    <div data-testid="fall-in-risk-legend">
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle} id="fall-in">
          {getClientTerm(`map.legend.fallIn.title`)}
          <HelpPopover
            link={getClientTerm(`map.legend.fallIn.help.link`)}
            linkText={getClientTerm(`map.legend.fallIn.help.linkText`)}
            fontSize="sm"
          />
        </div>
      )}
      <div className={`${legendClasses.legend} ${classes.layout}`}>
        {treeTypes
          .filter((t) => props.layerConfig[`show${capitalize(t)}Trees`])
          .map((treeType) => (
            <span key={treeType} className={classes.item}>
              <Icon name={`${capitalize(treeType)}Trees`} size={16} />
              <span>{getClientTerm(`map.legend.${treeType}TreesTitle`)}</span>
            </span>
          ))}
      </div>
    </div>
  );
};
